var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, CheckboxField } from '@pinwheel/origami';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectIncomeSources, setIncomeSources, } from '../../state/slices/slice-wizard';
import { useAppSelector } from '../../state';
import BaseWizardScreen from './BaseWizardScreen';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
export default function WizardIncomeSources() {
    var navigate = useLinkNavigate();
    var dispatch = useDispatch();
    var getLocalizedString = useGetLocalizedString();
    var incomeSources = useAppSelector(selectIncomeSources);
    var incomeSourceSelected = useCallback(function (source) {
        return (incomeSources.incomeSources.find(function (val) { return val === source; }) !== undefined);
    }, [incomeSources]);
    var _a = useState(incomeSourceSelected('w2')), checkboxW2Selected = _a[0], setCheckboxW2Selected = _a[1];
    var _b = useState(incomeSourceSelected('1099')), checkbox1099Selected = _b[0], setCheckbox1099Selected = _b[1];
    var _c = useState(incomeSourceSelected('benefits')), checkboxBenefitsSelected = _c[0], setCheckboxBenefitsSelected = _c[1];
    var _d = useState(incomeSourceSelected('self-employed')), checkboxSelfEmployedSelected = _d[0], setCheckboxSelfEmployedSelected = _d[1];
    var _e = useState(null), tempIncomeSources = _e[0], setTempIncomeSources = _e[1];
    useEffect(function () {
        var incomeSourcesSelected = [];
        if (checkbox1099Selected) {
            incomeSourcesSelected.push('1099');
        }
        if (checkboxBenefitsSelected) {
            incomeSourcesSelected.push('benefits');
        }
        if (checkboxW2Selected) {
            incomeSourcesSelected.push('w2');
        }
        if (checkboxSelfEmployedSelected) {
            incomeSourcesSelected.push('self-employed');
        }
        var updatedState = {
            visited: true,
            anyIncome: incomeSourcesSelected.length > 0,
            incomeSources: incomeSourcesSelected,
        };
        setTempIncomeSources(updatedState);
    }, [
        checkbox1099Selected,
        checkboxBenefitsSelected,
        checkboxSelfEmployedSelected,
        checkboxW2Selected,
    ]);
    var checkboxes = useMemo(function () { return (React.createElement(React.Fragment, null,
        React.createElement(CheckboxField, { "data-testid": "w2-employment", checked: checkboxW2Selected, onChange: setCheckboxW2Selected, label: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_W2'), subtitle: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_W2_DESC') }),
        React.createElement(CheckboxField, { "data-testid": "1099-employment", checked: checkbox1099Selected, onChange: setCheckbox1099Selected, label: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_1099'), subtitle: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_1099_DESC') }),
        React.createElement(CheckboxField, { "data-testid": "benefits", checked: checkboxBenefitsSelected, onChange: setCheckboxBenefitsSelected, label: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_BENEFITS'), subtitle: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_BENEFITS_DESC') }),
        React.createElement(CheckboxField, { "data-testid": "self-employed", checked: checkboxSelfEmployedSelected, onChange: setCheckboxSelfEmployedSelected, label: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_SELF_EMPLOYED'), subtitle: getLocalizedString('WIZARD_INCOME_SOURCES_CHECKBOX_SELF_EMPLOYED_DESC') }))); }, [
        checkbox1099Selected,
        checkboxBenefitsSelected,
        checkboxSelfEmployedSelected,
        checkboxW2Selected,
        getLocalizedString,
    ]);
    var buttons = useMemo(function () { return (React.createElement(React.Fragment, null,
        React.createElement(Button, { disabled: tempIncomeSources === null || !tempIncomeSources.anyIncome, onClick: function () {
                if (tempIncomeSources) {
                    dispatch(setIncomeSources(tempIncomeSources));
                }
                return navigate('/wizard/payment-methods');
            }, dataTestId: "Continue" }, getLocalizedString('CONTINUE')),
        React.createElement(Button, { disabled: tempIncomeSources !== null && tempIncomeSources.anyIncome, onClick: function () {
                if (tempIncomeSources) {
                    dispatch(setIncomeSources(__assign(__assign({}, tempIncomeSources), { incomeSources: ['no-income'] })));
                }
                return navigate('/wizard/wizard-error');
            }, variant: "ghost", dataTestId: "NoIncome" }, getLocalizedString('NO_INCOME')))); }, [tempIncomeSources, getLocalizedString, navigate, dispatch]);
    return (React.createElement(BaseWizardScreen, { dataTestId: "Wizard-IncomeSources", titleText: getLocalizedString('WIZARD_INCOME_SOURCES_TITLE'), subtitleText: getLocalizedString('CHECK_ALL_THAT_APPLY'), buttons: buttons, includeTermsFooter: true }, checkboxes));
}
